import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Link, Route, Routes, useParams } from "react-router-dom";
import { PeopleRow } from "../classes/PeopleRow.js"
import { useNavigate } from "react-router-dom";
import '../styles/CompanyDetails.css';
import helpButton from "../images/help.png"

var activeOverview = null
var skillsForEmail = []

function adjustArrows(down) {
    var clickedArrow = document.getElementById(down)

    var arrows = document.getElementsByClassName("arrow")

    for (var arrow of arrows) {
        if (arrow.classList.contains("up")) {
            arrow.classList.remove("up")
            arrow.classList.add("down")

            if (clickedArrow == arrow) {
                return
            }
        }
    }

    clickedArrow.classList.remove("down")
    clickedArrow.classList.add("up")
}

function filterRows(rows, settings) {
    for (var i = 0; i < rows.length; i++) {
        if (rows[i].lastConfirmedDate == "Unknown") {
            rows[i] = null
            continue
        }

        var year = rows[i].lastConfirmedDate.split("-")[0]
        if (parseInt(year) < settings.startYear) {
            rows[i] = null
        }
    }

    var newRows = []
    for (var row of rows) {
        if (row != null) {
            newRows.push(row)
        }
    }

    return newRows
}

function sortRows(rows) {
    rows = rows.sort((row1, row2) => {
        if (row1.source != row2.source) {
            if (row1.source == "Bullhorn") { return -1 }
            if (row2.source == "Bullhorn") { return 1 }
            if (row1.source == "Dice") { return -1 }
            return 1
        }

        return (row1.lastConfirmedDate > row2.lastConfirmedDate) ? -1 : 1
    })

    return rows
}

function showOverview(person) {
    if (activeOverview) {
        activeOverview.remove()

        if (activeOverview.id.includes(person.name)) {
            activeOverview = null
            return
        }
    }

    const companyRowIndex = document.getElementById(person.name).rowIndex
    const table = document.getElementById("myTable")

    const newRow = table.insertRow(companyRowIndex + 1)
    newRow.classList.add("companyOverview")
    newRow.id = person.name + "Overview"

    var overview = ""
    overview += "<td colspan=10>"

    if (person.source == "SalesIntel") {
        const linkedinURL = "https://www.linkedin.com/search/results/people/?keywords=" + person.name + "&company=" + person.companyPrimaryName + "&origin=GLOBAL_SEARCH_HEADER&sid=M%3A-"
        overview += "<h1 class='text-decoration-underline'><a href='" + linkedinURL + "' target='_blank'>" + person.name + "</a></h1>"
    } else {
        overview += "<h1 class='text-decoration-underline'><a href='/personDetails/" + person.consultantID + "' target='_blank'>" + person.name + "</a></h1>"
    }

    overview += "<p class='px-5 pt-3'><strong>Skills Overview</strong><br><div class='px-5 mx-5 row'><ul class='leftColumn'>"

    for (var skill of person.skills.slice(0, 10)) {
        overview += "<li class='skillListItem text-start'>" + skill + "</li>"
    }

    overview += "</ul><ul class='rightColumn'>"

    for (var skill of person.skills.slice(10, 20)) {
        overview += "<li class='skillListItem text-start'>" + skill + "</li>"
    }

    overview += "</ul></div></p></td>"

    newRow.innerHTML = overview
    activeOverview = newRow
}

function save(setter, data, manager) {
    const processing = document.getElementById("processing")
    const success = document.getElementById("success")
    const newAliases = document.getElementById("aliases").value
    processing.style.display = "flex"
    success.style.display = "none"

    manager.request("getCompanyDetails", "POST", { stripedCompanyName: data.stripedName, newAliases: newAliases }).then(res => res.json()).then((response) => {
        processing.style.display = "none"
        success.style.display = "flex"
        setter(Object.assign({}, response))
    })
}

function updateRecomendations() {
    const recs = document.getElementById("recommendations")
    const button = document.getElementById("recommendationsButton")

    if (recs.style.display == "none") {
        button.value = "Hide Recommendations"
        recs.style.display = ""
    } else {
        button.value = "Get Daxtra Recommendations"
        recs.style.display = "none"
    }
}

function adjustSkillsInEmail(event, skill) {
    event.preventDefault()
    var element = event.nativeEvent.srcElement.parentElement

    if (skillsForEmail.includes(skill)) {
        element.classList.remove("bg-warning")
        skillsForEmail.splice(skillsForEmail.indexOf(skill), 1)
    } else {
        element.classList.add("bg-warning")
        skillsForEmail.push(skill)
    }

    // console.log(skillsForEmail)
}

function getEmail(skillNames, companyPrimaryName, requestManager) {
    skillNames = (skillsForEmail.length > 0) ? skillsForEmail : skillNames
    var emailBox = document.getElementById("emailBox")
    var emailDiv = document.getElementById("emailDiv")
    var loadingBox = document.getElementById("loadingBox")
    emailDiv.style.display = "none"
    loadingBox.style.display = ""

    console.log(skillNames)

    requestManager.request("getCompanyDetails", "POST", { companyPrimaryName: companyPrimaryName, generateEmailFromSkills: skillNames }).then(res => res.json()).then((response) => {
        var email = response.email
        emailBox.innerHTML = email.replaceAll("\n", "<br>")
        emailDiv.style.display = ""
        loadingBox.style.display = "none"
    })
}

function SkillTable(args) {
    function showDescription(skill) {
        // console.log(skill)
        row = document.getElementById(skill + "Description")
        // console.log(row)

        if (row.style.display == "none") {
            row.style.display = ""
        } else {
            row.style.display = "none"
        }
    }

    var requestManager = args.requestManager

    var peopleRows = args.rows
    var skills = {}
    var diceAndBhCons = 0

    for (var row of peopleRows) {
        var seenInRow = []
        for (var skill of row.skills) {
            skill = skill.toLowerCase()

            if (skill == "" || seenInRow.includes(skill)) {
                continue
            }

            if (!skills.hasOwnProperty(skill)) {
                skills[skill] = 0
            }

            skills[skill] += 1
            seenInRow.push(skill)
        }

        if (row.source == "Bullhorn" || row.source == "Dice") {
            diceAndBhCons += 1
        }
    }

    var skillRows = Object.entries(skills)
    skillRows.sort((row1, row2) => {
        return row2[1] - row1[1]
    })

    for (var i = 0; i < skillRows.length; i++) {
        var percentage = Math.round(100.0 * skillRows[i][1] / diceAndBhCons)

        if (percentage > 20 && i < 15) {
            skillRows[i].push(percentage)
        } else {
            skillRows[i] = null
        }
    }

    var actualSkillRows = []
    var skillNames = []
    for (var row of skillRows) {
        if (row != null) {
            actualSkillRows.push(row)
            skillNames.push(row[0])
        }
    }

    skillRows = actualSkillRows
    var skillDescriptions = args.skillDescriptions
    // window.addEventListener("contextmenu", e => e.preventDefault());

    return (
        <div>
            {
                (skillRows.length == 0) ?
                    (<p></p>) :
                    (<>
                        <div class="column-12 d-flex justify-content-center pt-4">
                            <h1 class="display-5 fw-bold">Top Skills</h1>
                        </div>
                        <div class="col-12" id="table-wrapper" style={{ width: "70%" }}>
                            <table id="myTable" class="table table-bordered table-striped sortable border-2 border-dark text-center">
                                <thead class="stickyHeader">
                                    <tr class="table-success border-2 border-dark border-top-0">
                                        <th>Skill</th>
                                        <th>Number</th>
                                        <th>Percentage</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {skillRows.map((row) =>
                                        <>
                                            <tr id={row[0]} onClick={() => showDescription(row[0])} onContextMenu={(e) => adjustSkillsInEmail(e, row[0])}>
                                                <td class="title">{row[0]}</td>
                                                <td>{row[1]}</td>
                                                <td>{row[2]}%</td>
                                            </tr>
                                            <tr class="skillDescription" id={row[0] + "Description"} style={{ display: "none" }} >
                                                {
                                                    (row[0] in skillDescriptions) ?
                                                        (<td colspan="3">{skillDescriptions[row[0]]}</td>) :
                                                        (<td colspan="3"><a href={"https://www.google.com/search?q=What+is+" + row[0]} target="_blank">Description</a></td>)
                                                }
                                            </tr>
                                        </>
                                    )}
                                </tbody>
                                <tfoot></tfoot>
                            </table>
                        </div>
                    </>)}
            <div class="d-flex justify-content-center mt-2" style={{marginBottom: "0px"}}>
                <p>Right-click on above skills to use them in email</p>
            </div>
            <div class="d-flex justify-content-center pb-2">
                <input type="submit" method="post" onClick={() => getEmail(skillNames, args.rows[0].companyPrimaryName, requestManager)} value="Generate Email" class="btn btn-primary d-flex justify-content-center" style={{ width: "20%" }}></input>
            </div>
            <div class="d-flex justify-content-center pb-2">
                <p style={{ display: "none" }} id="loadingBox">Loading, this may take up to 20 seconds...</p>
            </div>
            <div id="emailDiv" style={{ display: "none" }}>
                <div class="d-flex justify-content-left justify-content-star pb-2 border border-4 border-dark">
                    <p id="emailBox" style={{ all: "initial" }} class="p-2"></p>
                </div>
            </div>
        </div>
    )
}

function CompanyDetails(args) {
    const currentAuthKey = document.cookie.split("; ").find((row) => row.startsWith("authKey="))?.split("=")[1]
    const navigate = useNavigate()
    const requestManager = args.requestManager

    useEffect(() => {
        if (typeof currentAuthKey === "undefined") {
            navigate("/login")
        } else if (typeof data.keyError !== "undefined") {
            if (data.keyError === "notAuthorized") {
                navigate("/")
            } else {
                navigate("/login")
            }
        }
    })

    const { stripedName } = useParams()
    const [data, setData] = useState([{}])

    var rows = []

    if (typeof data.status !== "undefined" && typeof data.keyError === "undefined") {
        for (var row of data.rows) {
            var person = new PeopleRow()
            person.initalize(row)
            rows.push(person)
        }

        rows = filterRows(rows, data.settings)
        rows = sortRows(rows)
    } else {
        requestManager.request("getCompanyDetails", "POST", { stripedCompanyName: stripedName }).then(res => res.json()).then((response) => {
            setData(response)
        })
    }

    // console.log(data.quickInfo)

    return (
        <div class="container">
            <div class="pt-5 pb-5 mb-5 text-center">
                {
                    (typeof data.status === "undefined" || typeof data.keyError !== "undefined") ?
                        (<h1 class="loading">Loading</h1>) :
                        (<div>
                            <h1 class="display-2 fw-bold"><u>{data.primaryName}</u></h1>
                            <div class="row">
                                <div class="column-12 d-flex justify-content-center pt-4">
                                    <h1 class="display-5 fw-bold">Quick Info</h1>
                                </div>
                                <table class="table table-stripped table-bordered border-2 border-dark text-center sortable">
                                    <thead>
                                        <tr class="table-success border-2 border-dark">
                                            <th class="col-2">Links</th>
                                            <th class="col-5">Aliases<img src={helpButton} class="mx-1 mb-1" width="15" height="15" alt="" title="Along with punctuation, the following extension are removed by default: inc, incorporated, solutions, company, corp, llc, ltd, llp, limited, bank, group, securities, the, technology, technologies, us, usa, corporation, systems, software, investment, industries, international, health, global, clearing, mobility, services, co."></img></th>
                                            {/* <th class="col-2">Industries</th> */}
                                            <th class="col-5">Description</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                {Object.keys(data.quickInfo.links).map((name, i) => (
                                                    <>
                                                        <a href={data.quickInfo.links[name]} target="_blank">{name}</a>
                                                        <br></br>
                                                    </>
                                                ))}
                                            </td>
                                            <td>
                                                <textarea style={{ height: "130px" }} id="aliases" class="form-text form-control" autocomplete="off" defaultValue={data.quickInfo.aliases}></textarea>
                                                <div class="pt-3" id="recommendations" style={{ display: "none" }}>
                                                    <h5>Recommended Aliases</h5>
                                                    <ul>
                                                        {
                                                            data.reccomendedAliases.map((alias) => (
                                                                <li class="text-start">{alias}</li>
                                                            ))
                                                        }
                                                    </ul>
                                                </div>
                                                {/* <div class="d-flex justify-content-center pt-3 mt-3">
                                                    <input type="submit" method="post" id="recommendationsButton" onClick={() => updateRecomendations()} value="Get Daxtra Recommendations" class="btn btn-secondary mt-3 d-flex justify-content-center" style={{ width: "50%" }}></input>
                                                </div> */}
                                                <div class="d-flex justify-content-center pb-2">
                                                    <input type="submit" method="post" onClick={() => save(setData, data, requestManager)} value="Save" class="btn btn-success mt-3 d-flex justify-content-center" style={{ width: "40%" }}></input>
                                                </div>
                                                <div class="justify-content-center" style={{ display: "none" }} id="processing">
                                                    <h4 class="text-secondary">Processing...</h4>
                                                </div>
                                                <div class="justify-content-center" style={{ display: "none" }} id="success">
                                                    <h4 class="text-success">Success!</h4>
                                                </div>
                                            </td>
                                            {/* <td>{data.quickInfo.industries}</td> */}
                                            <td>{data.quickInfo.description}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                {
                                    (data.failedGPTCheck) ?
                                        (<div class="justify-content-center py-1" id="failedGPTCheck">
                                            <h1 class="text-danger">Sorry, one or more of the Aliases you submitted could not be verified automatically. An email has been seent to an Admin to manually approve it.</h1>
                                        </div>) :
                                        (<></>)
                                }
                            </div>
                            <div class="column-12 d-flex justify-content-center">
                                <h1 class="display-5 fw-bold pt-4">Known Consultants</h1>
                            </div>
                            <div class="col-12 mb-2 d-flex" id="table-wrapper">
                                <table id="myTable" class="table-fixed table table-bordered table-striped sortable border-2 border-dark text-center">
                                    <thead class="stickyHeader">
                                        <tr class="table-success border-2 border-dark border-top-0">
                                            <th>Name</th>
                                            <th>Title</th>
                                            <th>Last Confirmed Date</th>
                                            <th>Source</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rows.map((row) =>
                                            (row.source !== "SalesIntel") ?
                                                (<tr id={row.name}>
                                                    <td><a href={"/personDetails/" + row.consultantID} target="_blank">{row.name}</a></td>
                                                    <td class="titleCell">{row.title}</td>
                                                    <td>{row.lastConfirmedDate}</td>
                                                    <td>{row.source}</td>
                                                </tr>) :
                                                // (<tr id={row.name} onClick={() => { adjustArrows(row.name + "Arrow"); showOverview(row); }}>
                                                //     <td>{row.name}<i class="arrow down mx-2 mb-1" id={row.name + "Arrow"}></i></td>
                                                //     <td class="titleCell">{row.title}</td>
                                                //     <td>{row.lastConfirmedDate}</td>
                                                //     <td>{row.source}</td>
                                                // </tr>) :
                                                (<tr id={row.name}>
                                                    <td><a href={"https://www.linkedin.com/search/results/people/?keywords=" + row.name + "&company=" + row.companyPrimaryName + "&origin=GLOBAL_SEARCH_HEADER&sid=M%3A-"} target="_blank">{row.name}</a></td>
                                                    <td class="titleCell">{row.title}</td>
                                                    <td>{row.lastConfirmedDate}</td>
                                                    <td>{row.source}</td>
                                                </tr>)
                                        )
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <SkillTable rows={rows} skillDescriptions={data.skillDescriptions} requestManager={requestManager} />
                        </div>)
                }
            </div>
        </div>

    )
}

export default CompanyDetails